"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabKeyPrefix = exports.defaultTabsWidth = exports.defaultTopPadding = exports.defaultTabIndex = exports.classes = void 0;
var classes = {
  verticalTabsUlList: 'bds-vertical-tabs-ul-list',
  verticalLi: 'bds-vertical-li',
  selectedVerticalLi: 'bds-selected-vertical-li',
  verticalLiWithIcon: 'bds-vertical-li-with-icon',
  selectedVerticalLiWithIcon: 'bds-selected-vertical-li-with-icon',
  verticalTabContainer: 'bds-vertical-tab-container',
  verticalTabIconContainer: 'bds-vertical-tab-icon-container',
  verticalTabTitle: 'bds-vertical-tab-title',
  selectedVerticalTabTitle: 'bds-selected-vertical-tab-title'
};
exports.classes = classes;
var defaultTabIndex = '0';
exports.defaultTabIndex = defaultTabIndex;
var defaultTopPadding = '48px';
exports.defaultTopPadding = defaultTopPadding;
var defaultTabsWidth = '288px';
exports.defaultTabsWidth = defaultTabsWidth;
var tabKeyPrefix = 'tab-item-';
exports.tabKeyPrefix = tabKeyPrefix;